// extracted by mini-css-extract-plugin
module.exports = {"odd-container":"odd_odd-container__2KpS7","odd-item":"odd_odd-item__1bSJM","type":"odd_type__2soqr","value":"odd_value__CLIbi"};